module.exports = __webpack_public_path__ + "kn.svg?a1e5c90bb158a324df6f2f416b58a1a5";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/kn.svg
// module id = 1194
// module chunks = 0